export const developersTableHeaders = [
  {
    text: 'NAME',
    align: 'start',
    sortable: true,
    value: 'full_name',
  },
  {
    text: 'POSITION',
    align: 'start',
    sortable: false,
    value: 'role',
  },
  {
    text: 'LEVEL',
    align: 'start',
    sortable: false,
    value: 'level',
  },
  {
    text: 'TOP SKILLS',
    align: 'start',
    sortable: false,
    value: 'top_skills',
  },
  {
    text: 'RATE',
    align: 'start',
    sortable: true,
    value: 'rate',
    width: 120,
  },
  {
    text: 'TYPE',
    align: 'start',
    sortable: true,
    value: 'status',
    width: 96,
  },
  {
    text: 'AVAILABILITY',
    align: 'start',
    sortable: true,
    value: 'availability',
  },
  {
    text: 'CREATED AT',
    align: 'start',
    sortable: true,
    value: 'created_date',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 90,
    class: 'px-2',
  },
];

export const projectMembersTable = [
  {
    text: 'NAME',
    align: 'start',
    sortable: true,
    value: 'full_name',
  },
  {
    text: 'POSITION',
    align: 'start',
    sortable: true,
    value: 'positions',
  },
  {
    text: 'LEVEL',
    align: 'start',
    sortable: true,
    value: 'level',
  },
  {
    text: 'RATE',
    align: 'start',
    sortable: true,
    value: 'developer_rate',
    width: 120,
  },
  {
    text: 'CONTRACT',
    align: 'start',
    sortable: false,
    value: 'contract',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 100,
  },
];

export const projectMembersReportsTable = [
  {
    text: 'NAME',
    align: 'start',
    sortable: true,
    value: 'full_name',
  },
  {
    text: 'POSITION',
    align: 'start',
    sortable: true,
    value: 'roles',
  },
  {
    text: 'DURATION',
    align: 'start',
    sortable: true,
    value: 'time_worked_in_seconds',
  },
  {
    text: 'RATE',
    align: 'start',
    sortable: true,
    value: 'rate',
    width: 120,
  },
  {
    text: 'COST',
    align: 'start',
    sortable: false,
    value: 'amount',
  },
  {
    text: 'STATUS',
    align: 'start',
    sortable: false,
    value: 'status',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 100,
  },
];

export const recruitmentsTable = [
  {
    text: 'POSITION',
    align: 'start',
    sortable: true,
    value: 'position',
  },
  {
    text: 'TIME',
    align: 'start',
    sortable: true,
    value: 'time',
  },
  {
    text: 'LEVEL',
    align: 'start',
    sortable: true,
    value: 'level',
  },
  {
    text: 'MINIMUM EXPERIENCE',
    align: 'start',
    sortable: false,
    value: 'experience_in_years',
  },
  {
    text: 'RATE',
    align: 'start',
    sortable: true,
    value: 'rate',
  },
  {
    text: 'CANDIDATES',
    align: 'start',
    sortable: true,
    value: 'candidates_count',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
  },
];

export const recruitmentsHrTable = [
  {
    text: 'POSITION',
    align: 'start',
    sortable: true,
    value: 'position',
  },
  {
    text: 'TIME',
    align: 'start',
    sortable: true,
    value: 'time',
  },
  {
    text: 'LEVEL',
    align: 'start',
    sortable: true,
    value: 'level',
  },
  {
    text: 'MINIMUM EXPERIENCE',
    align: 'start',
    sortable: false,
    value: 'experience_in_years',
  },
  {
    text: 'RATE',
    align: 'start',
    sortable: true,
    value: 'rate',
  },
  {
    text: 'CANDIDATES',
    align: 'start',
    sortable: true,
    value: 'candidates_count',
  },
  {
    text: 'STATUS',
    align: 'start',
    sortable: true,
    value: 'status',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
  },
];

export const recruitmentApplicationsTable = [
  {
    text: '',
    align: 'left',
    sortable: true,
    value: 'index',
    width: 10,
  },
  {
    text: 'NAME',
    align: 'start',
    sortable: true,
    value: 'full_name',
  },
  {
    text: 'POSITION',
    align: 'start',
    sortable: true,
    value: 'position',
  },
  {
    text: 'LEVEL',
    align: 'start',
    sortable: true,
    value: 'level',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 100,
  },
];

export const candidatesTableHeaders = [
  {
    text: '',
    align: 'left',
    sortable: false,
    value: 'add',
    width: 24,
  },
  {
    text: 'NAME',
    align: 'start',
    sortable: true,
    value: 'full_name',
  },
  {
    text: 'MATCHED',
    align: 'start',
    sortable: false,
    value: 'score',
  },
  {
    text: 'LEVEL',
    align: 'start',
    sortable: false,
    value: 'level',
  },
  {
    text: 'RATE',
    align: 'start',
    sortable: true,
    value: 'rate',
    width: 120,
  },
  {
    text: 'TOP SKILLS',
    align: 'start',
    sortable: false,
    value: 'top_skills',
  },
  {
    text: 'AVAILABILITY',
    align: 'start',
    sortable: true,
    value: 'availability',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 90,
    class: 'px-2',
  },
];

export const issuesHrTableHeaders = [
  {
    text: 'TITLE',
    align: 'start',
    sortable: true,
    value: 'title',
  },
  {
    text: 'NR ISSUE',
    align: 'start',
    sortable: true,
    value: 'id',
  },
  {
    text: 'POST DATE',
    align: 'start',
    sortable: true,
    value: 'post_date',
  },
  {
    text: 'CLIENT NAME',
    align: 'start',
    sortable: true,
    value: 'client_name',
  },
  {
    text: 'PROJECT',
    align: 'start',
    sortable: true,
    value: 'project_name',
  },
  {
    text: 'STATUS',
    align: 'start',
    sortable: true,
    value: 'status',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 90,
    class: 'px-2',
  },
];

export const issuesTableHeaders = [
  {
    text: 'TITLE',
    align: 'start',
    sortable: true,
    value: 'title',
  },
  {
    text: 'NR ISSUE',
    align: 'start',
    sortable: true,
    value: 'id',
  },
  {
    text: 'POST DATE',
    align: 'start',
    sortable: true,
    value: 'post_date',
  },
  {
    text: 'NAME OF DEVELOPER',
    align: 'start',
    sortable: true,
    value: 'developer_name',
  },
  {
    text: 'PROJECT',
    align: 'start',
    sortable: true,
    value: 'project_name',
  },
  {
    text: 'STATUS',
    align: 'start',
    sortable: true,
    value: 'status',
  },
  {
    text: '',
    align: 'center',
    sortable: false,
    value: 'action',
    width: 90,
    class: 'px-2',
  },
];
